<template>

 <div>
  <md-toolbar class="md-transparent" >
    <md-button class="md-icon-button" @click="toggleLeftSidenav">
      <md-icon>menu</md-icon>
    </md-button>
  </md-toolbar>

  <md-sidenav class="md-left"  ref="leftSidenav" @open="open('Left')" @close="close('Left')">
    <md-toolbar class="md-large navEdit" >
      <div class="md-toolbar-container" >
        <h1 class="navHeading" > WorkTeen<hr class="navHR"> </h1>
      </div>
    </md-toolbar>

    <div >
      <md-list>
        <md-list-item >
          <md-icon>home</md-icon> <span><router-link to="/">Home</router-link></span>
        </md-list-item>

        <md-list-item >
          <md-icon>people</md-icon> <span><router-link to="/about">About Us</router-link></span>
        </md-list-item>
        <md-list-item >
          <md-icon>android</md-icon> <span><router-link to="/bot">Our Bot</router-link></span>
        </md-list-item>
    </md-list>
    </div>
    </md-sidenav>
</div>
</template>

<script>
export default {
  methods: {
    toggleLeftSidenav() {
      this.$refs.leftSidenav.toggle();
    },
    toggleRightSidenav() {
      this.$refs.rightSidenav.toggle();
    },
    closeRightSidenav() {
      this.$refs.rightSidenav.close();
    },
    open(ref) {
      console.log('Opened: ' + ref);
    },
    close(ref) {
      console.log('Closed: ' + ref);
    }
  }
};
</script>


<style scoped>
.navEdit{
  /*background-color:#427AA1 !important;*/
  background-color: white !important;
  color: #427AA1;
}


nav{
  background-color: transparent;
  color:#ebf2fa ;
  border: 0px solid white;

}
.md-button, p{
  color:#05668d ;
  font-size: 1.1em;
}
body{
  font-family: 'Lato', Helvetica, Arial, sans-serif;
}
p:hover{
  color:#e2c044 ;
  text-decoration: none;
}
a:hover{
  text-decoration: none;
}


li{
  color:#05668d !important;
  font-size : 20px;
  padding : 5px;
}

.navHeading {
  font-family: 'Alegreya Sans SC', sans-serif;
    padding-top:50%;
    padding-left:16%;
    color: #427AA1;
    font-size:2.8em;


}
.md-list-item-container{
  color:yellow !important;
}
md-toolbar{
  width:100px !important;
}
hr .navHR{
  border:1px solid #427AA1;
  margin-top:10%;
  width:100%;
}
</style>



// WEBPACK FOOTER //
// Navs.vue?2f9ffc24